import * as variables from './variables';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu } from './component/MainMenu';
new MainMenu({
	menuID: 'menu',
	toggles: '.menuToggle',
	focusLock: {
		dialog: '.menu',
		return: '.menuToggle--open',
		toggle: '.menuToggle--close'
	},
	styleClass: {
		menuOpen: 'hasMenuOpen'
	}
});

// Events
// On tab panels set ARIA attributes that cannot set on group block
const eventsCalendarListViewPanel = document.querySelector(".panel--list-view"); // Modify group block wrapping event "list view" results
if (eventsCalendarListViewPanel) {
	eventsCalendarListViewPanel.setAttribute("role", "tabpanel");
	eventsCalendarListViewPanel.setAttribute("aria-labelledby", "list-view");
}
import Tabs from './component/tabs';
new Tabs();


// Fallbacks for using :has selector. Delete this and related CSS after Firefox starts supporting it.
const cardListings = document.querySelectorAll('.cardListing');
if (cardListings) {
	cardListings.forEach(element => {
		if(element.querySelector('.arrowCard')) {
			element.classList.add('cardListing--hasArrowCard');
		}
		if(element.querySelector('.iconCard')) {
			element.classList.add('cardListing--hasIconCard');
		}
	});
}
const plauditQueryLoops = document.querySelectorAll('.plauditQueryLoop');
if (plauditQueryLoops) {
	plauditQueryLoops.forEach(element => {
		if(element.querySelector('.plauditQueryLoop__sidebar')) {
			element.classList.add('plauditQueryLoop--hasSidebar');
		}
	});
}



// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance([
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .pageFooter__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .pageFooter__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// ]);
// ---------------------------------------------------------------------------------------------- //
